import {riskManagementComponent, RiskManagementComponent} from "./RiskManagementComponent";
import {brokerRiskRow, BrokerRiskRow} from "./broker/BrokerRiskRowComponent";
import {branchRiskRow, BranchRiskRow} from "./branch/BranchRiskRowComponent";
import {adviserRiskRow, AdviserRiskRow} from "./adviser/AdviserRiskRowComponent";
import {clientRiskRow, ClientRiskRow} from "./client/ClientRiskRowComponent";
import {riskRowDetail, RiskRowDetail} from "./detail/RiskRowDetailComponent";
import {riskChangeControls, RiskChangeControls} from "./detail/controls/RiskChangeControls";
import {collapseIcon, CollapseIcon} from "./collapse-icon/CollapseIcon";
import {summaryRow, SummaryRow} from "./summary/DashboardSummaryRowComponent";

export default angular.module("tfApp.risk.dashboard.grid", [])
                      .component(RiskManagementComponent, riskManagementComponent())
                      .component(BrokerRiskRow, brokerRiskRow())
                      .component(BranchRiskRow, branchRiskRow())
                      .component(AdviserRiskRow, adviserRiskRow())
                      .component(ClientRiskRow, clientRiskRow())
                      .component(RiskRowDetail, riskRowDetail())
                      .component(RiskChangeControls, riskChangeControls())
                      .component(CollapseIcon, collapseIcon())
                      .component(SummaryRow, summaryRow())
                      .name;
